function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TuvaluFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_775",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_775)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#00B4FF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_775",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_775)",
      children: [/*#__PURE__*/_jsx("rect", {
        y: "3",
        width: "13.5",
        height: "10.5",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_775",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "3",
        width: "14",
        height: "11",
        children: /*#__PURE__*/_jsx("rect", {
          y: "3",
          width: "13.5",
          height: "10.5",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_775)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M-1.50317 12.7499L1.46754 14.0528L13.5674 4.41657L15.1344 2.48042L11.9577 2.04495L7.02241 6.19747L3.05003 8.9953L-1.50317 12.7499Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M-1.0965 13.6627L0.416945 14.4188L14.5717 2.30052H12.4467L-1.0965 13.6627Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M15.0032 12.7499L12.0325 14.0528L-0.0673752 4.41657L-1.63436 2.48042L1.54239 2.04495L6.47765 6.19747L10.45 8.9953L15.0032 12.7499Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14.9019 13.405L13.3884 14.1611L7.36117 8.9726L5.57422 8.39291L-1.78515 2.48701H0.339895L7.69513 8.25273L9.64885 8.94784L14.9019 13.405Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsxs("mask", {
          id: "path-10-outside-1_621_775",
          maskUnits: "userSpaceOnUse",
          x: "-1",
          y: "2",
          width: "16",
          height: "13",
          fill: "black",
          children: [/*#__PURE__*/_jsx("rect", {
            fill: "white",
            x: "-1",
            y: "2",
            width: "16",
            height: "13"
          }), /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z"
          })]
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M5.98838 3V2.25H5.23838V3H5.98838ZM7.48838 3H8.23838V2.25H7.48838V3ZM5.98838 7.5V8.25H6.73838V7.5H5.98838ZM0 7.5V6.75H-0.75V7.5H0ZM0 9H-0.75V9.75H0V9ZM5.98838 9H6.73838V8.25H5.98838V9ZM5.98838 13.5H5.23838V14.25H5.98838V13.5ZM7.48838 13.5V14.25H8.23838V13.5H7.48838ZM7.48838 9V8.25H6.73838V9H7.48838ZM13.5 9V9.75H14.25V9H13.5ZM13.5 7.5H14.25V6.75H13.5V7.5ZM7.48838 7.5H6.73838V8.25H7.48838V7.5ZM5.98838 3.75H7.48838V2.25H5.98838V3.75ZM6.73838 7.5V3H5.23838V7.5H6.73838ZM0 8.25H5.98838V6.75H0V8.25ZM0.75 9V7.5H-0.75V9H0.75ZM5.98838 8.25H0V9.75H5.98838V8.25ZM6.73838 13.5V9H5.23838V13.5H6.73838ZM7.48838 12.75H5.98838V14.25H7.48838V12.75ZM6.73838 9V13.5H8.23838V9H6.73838ZM13.5 8.25H7.48838V9.75H13.5V8.25ZM12.75 7.5V9H14.25V7.5H12.75ZM7.48838 8.25H13.5V6.75H7.48838V8.25ZM6.73838 3V7.5H8.23838V3H6.73838Z",
          fill: "#F7FCFF",
          mask: "url(#path-10-outside-1_621_775)"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.1425 11.0136L20.5979 10.1695L21.597 10.1397L20.8234 9.49364L21.0901 8.62169L20.4233 9.02237L19.5803 8.51113L19.6619 9.47987L18.9066 9.93371L19.8871 10.0563L20.1425 11.0136ZM17.5979 11.6695L17.1425 12.5136L16.8871 11.5563L15.9066 11.4337L16.6619 10.9799L16.5803 10.0111L17.4233 10.5224L18.0901 10.1217L17.8234 10.9936L18.597 11.6397L17.5979 11.6695ZM15.6425 14.0136L16.0979 13.1695L17.097 13.1397L16.3234 12.4936L16.5901 11.6217L15.9233 12.0224L15.0803 11.5111L15.1619 12.4799L14.4066 12.9337L15.3871 13.0563L15.6425 14.0136ZM12.6425 17.0136L13.0979 16.1695L14.097 16.1397L13.3234 15.4936L13.5901 14.6217L12.9233 15.0224L12.0803 14.5111L12.1619 15.4799L11.4066 15.9337L12.3871 16.0563L12.6425 17.0136ZM9.73059 19.3017L8.9055 19.7907L9.17961 18.8385L8.40228 18.2285H9.28346L9.71244 17.356L10.1718 18.2285H10.9497L10.272 18.8385L10.6023 19.7907L9.73059 19.3017ZM13.0979 19.1695L12.6425 20.0136L12.3871 19.0563L11.4066 18.9337L12.1619 18.4799L12.0803 17.5111L12.9233 18.0224L13.5901 17.6217L13.3234 18.4936L14.097 19.1397L13.0979 19.1695ZM16.0979 17.6695L15.6425 18.5136L15.3871 17.5563L14.4066 17.4337L15.1619 16.9799L15.0803 16.0111L15.9233 16.5224L16.5901 16.1217L16.3234 16.9936L17.097 17.6397L16.0979 17.6695ZM19.0979 16.1695L18.6425 17.0136L18.3871 16.0563L17.4066 15.9337L18.1619 15.4799L18.0803 14.5111L18.9233 15.0224L19.5901 14.6217L19.3234 15.4936L20.097 16.1397L19.0979 16.1695ZM20.1425 15.5136L20.5979 14.6695L21.597 14.6397L20.8234 13.9936L21.0901 13.1217L20.4233 13.5224L19.5803 13.0111L19.6619 13.9799L18.9066 14.4337L19.8871 14.5563L20.1425 15.5136Z",
        fill: "#FFD018"
      })]
    })]
  })]
}));
//# sourceMappingURL=Tuvalu.js.map